import { Button, IconButton, TextField } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { useState } from 'react';
import api from '../services/api';
import Dialog from '@mui/material/Dialog';
import { useSelector } from 'react-redux';
import MessageSuccess from '../messages/messageSuccess';
import MessageError from '../messages/messageError';
import { useNavigate } from 'react-router-dom';
import ButtonLeft from './buttonLeft';
import HeaderGestorConfigs from './headerGestorConfigs';

const Delete = (props) => {
    const reduxUserId = useSelector(state => state.account.user?._id);
    const userId = props.userId ?? reduxUserId;
    const [open, setOpen] = useState(false);
    const [messageSuccess, setMessageSuccess] = useState('')
    const [messageError, setMessageError] = useState('')
    const [observacao, setObservacao] = useState('');
    const [obsError, setObsError] = useState(false);
    const navigate = useNavigate()

    const handleClose = () => {
        props.setOpen(false);
    };

    const handleDelete = () => {
        setMessageSuccess('')
        setMessageError('')
        if (!userId) {
            setMessageError('Usuário não autenticado. Faça login novamente.');
            return;
        }
        if (!observacao || observacao.trim().length === 0) {
            setObsError(true);
            setMessageError('A observação é obrigatória para remover.');
            return;
        } else {
            setObsError(false);
        }
        setOpen(true)

        const dadosEnvio = { id: props.id, userId, observacao };
        api.delete(`${props.url}/`, { data: dadosEnvio })
            .then(response => {
                // console.log(response) 
                setOpen(false)
                setMessageSuccess(`${props.tipo} removido(a) com sucesso.`)

                setTimeout(() => {
                    navigate(-1)
                }, 5000);

            }).catch(err => {
                setOpen(false)
                setMessageError('Erro ao eliminar')
            })
    }

    return (
        <>
            {/* USAR COM O BOTAO APENAS SE FOR NECESSARIO */}
            {props?.button &&
                <IconButton color='error' title="Deletar" style={{ position: 'absolute', right: 5, top: 0, fontWeight: 'bold' }} onClick={() => props.setOpen(props?.id)}> <DeleteIcon /></IconButton>
            }

            <Dialog
                scroll='body'
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={props.open}
                // maxWidth={'md'}
                fullWidth
            >
                <div style={{ padding: 20 }}>
                    {messageSuccess && <MessageSuccess message={messageSuccess} />}
                    {messageError && <MessageError message={messageError} />}

                    <HeaderGestorConfigs title={props.msg + " ?"} />

                    <div style={{ marginBottom: 16 }}>
                        <TextField
                            id="observacao"
                            label="Observação para remoção"
                            multiline
                            minRows={3}
                            maxRows={6}
                            fullWidth
                            variant="outlined"
                            value={observacao}
                            onChange={e => { setObservacao(e.target.value); setObsError(false); }}
                            placeholder="Explique brevemente o motivo da exclusão dos dados..."
                            required
                            error={obsError}
                            helperText={obsError ? 'Campo obrigatório' : ''}
                        />
                    </div>

                    {!messageSuccess &&
                        <ButtonLeft
                            title={'Deletar'}
                            funcao={handleDelete}
                            load={open}
                            disabled={!observacao || observacao.trim().length === 0}
                        >
                            <Button title='Cancelar' color='error' onClick={() => props.setOpen(false)} size="small" >Cancelar</Button>
                        </ButtonLeft>
                    }
                </div>
            </Dialog>
        </>
    );
}

export default Delete;
